import { type SearchRequest } from '@searchkit/api';

import {
  getPremiumMarketMoversSorting,
  premiumMarketMoversResultAttributes,
} from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/query-config';
import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import { normalizeFacetFilters, withRequestParams } from '~/apps/product-plus/search-domain/utils';

export function buildPremiumMarketMoversQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mappedSearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getPremiumMarketMoversSorting();

  return createQueryFactory({
    resultAttributes: premiumMarketMoversResultAttributes,
    searchRequest: mappedSearchRequest,
    sorting,
  });
}
